import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import Modal from 'react-modal'
import ModalContent from "../../common/Modal/ModalContent";
import close_modal from '../../assets/ic_close_wh.svg'
import api from "../../utils/api";
import { toast } from "react-toastify";

const CustomHeader = ({ displayName }) => {
    return (
        <div style={{ display: "flex", width: '50px', alignItems: "center", whiteSpace: "normal" }}>
            {displayName}
        </div>
    );
};

const ServiceCatalogueTable = (props) => {

    const gridRef = useRef()
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);


    const [deleteId, setDeleteId] = useState()

    const confirmDelete = (e) => {
        setDeleteId(e.id)
        openConfirmationModalisTrue()

    }

    const [confirmationModal, setConfirmationModal] = useState(false)
    const openConfirmationModalisTrue = () => {
        setConfirmationModal(true)
    }

    const openConfirmationModalisFalse = () => {
        setConfirmationModal(false)
    }


    const deleteCatalogue = () => {
        api.deleteServiceCatalogueData({ id: deleteId })
            .then(({ data }) => {
                console.log("Delete", data)
                if (data.Message === "Service Catalogue Deleted Successfully.") {
                    toast("Catalogue Deleted Successfully", {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    })
                }
                props.getServiceCatalogueTableData()
                setConfirmationModal(false)
            })

    }

    const gridOptions = {
        // ... other grid options ...
        rowHeight: 40, // Adjust the row height here
    };

    const rowData = props.serviceCatalogueData

    const columnDefs = [
        { headerName: 'ID', field: 'id', headerComponentFramework: CustomHeader, width: 70 },
        { headerName: 'Catalogue ID', field: 'sCatalogueId', headerComponentFramework: CustomHeader, width: 450 },
        { headerName: 'Service Code', field: 'sServiceCode', headerComponentFramework: CustomHeader },
        { headerName: 'Delivery Mode', field: 'sDeliveryMode', headerComponentFramework: CustomHeader, width: 120 },
        { headerName: 'Payment Mode', field: 'sPaymentMode', headerComponentFramework: CustomHeader, width: 150 },
        { headerName: 'Payment Receiver', field: 'sPaymentReceiver', headerComponentFramework: CustomHeader, width: 100 },
        { headerName: 'Mode', field: 'sMode', headerComponentFramework: CustomHeader },
        { headerName: 'Amount First (₹)', field: 'fAmountFirst', headerComponentFramework: CustomHeader, width: 100 },
        { headerName: 'Amount Second (₹)', field: 'fAmountSecond', headerComponentFramework: CustomHeader, width: 100, width: 100 },
        { headerName: 'Amount Full (₹)', field: 'fAmountFull', headerComponentFramework: CustomHeader, width: 100 },
        { headerName: 'Key', field: 'nKey', headerComponentFramework: CustomHeader, width: 100 },
        { headerName: 'GST (%)', field: 'fGST', headerComponentFramework: CustomHeader, width: 100 },
        { headerName: 'Calculator Ref ID', field: 'sCalculatorRefId', headerComponentFramework: CustomHeader, width: 135 },
        { headerName: 'Expected TAT', field: 'nExpectedTAT', headerComponentFramework: CustomHeader, width: 100 },
        { headerName: 'Execution Owner', field: 'sExecutionOwner', headerComponentFramework: CustomHeader, width: 110 },
        // {
        //     headerName: 'Action',
        //     cellRendererFramework: (params) => {
        //         return (
        //             <>
        //                 {
        //                     params.data.is_deleted ?
        //                         <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center", pointerEvents: 'none', opacity: 0.4 }}>
        //                             <button
        //                                 type="button"
        //                                 onClick={() => props.editCatalogue(params.data)}
        //                                 className={`my-services-model-cancel-btn`}>Edit</button>
        //                             <button
        //                                 style={{
        //                                     width: "113px",
        //                                     margin: '5px 5px'
        //                                 }}
        //                                 onClick={() => confirmDelete(params.data)}
        //                                 className={`my-services-model-submit-btn`}>Deactivate</button>
        //                         </div>
        //                         :
        //                         <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
        //                             <button
        //                                 type="button"
        //                                 onClick={() => props.editCatalogue(params.data)}
        //                                 className={`my-services-model-cancel-btn`}>Edit</button>
        //                             <button
        //                                 style={{
        //                                     width: "113px",
        //                                     margin: '5px 5px'
        //                                 }}
        //                                 onClick={() => confirmDelete(params.data)}
        //                                 className={`my-services-model-submit-btn`}>Deactivate</button>
        //                         </div>
        //                 }
        //             </>
        //         );
        //     },
        //     headerComponentFramework: CustomHeader,
        //     width: 230,
        //     cellStyle: {
        //         'height': '100%',
        //         'display': 'flex ',
        //         'align-items': 'center ',
        //     },
        // },
    ];

    return (
        <div>
            {/* Confirmation Modal */}

            <Modal isOpen={confirmationModal} style={{ zIndex: 1 }}>
                <ModalContent className="confirmation-modal-small">
                    <div className="modal-header" style={{
                        backgroundColor: '#76287C',
                        color: '#fff'
                    }}>
                        <span className="modal-title">Confirm</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openConfirmationModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        Are you sure you want to perform this action?
                        <div className="row">
                            <div className="col-12 d-flex align-items-center" style={{
                                justifyContent: 'flex-end'
                            }}>
                                <button
                                    type="button"
                                    className="my-services-model-submit-btn conv-mr25"
                                    onClick={deleteCatalogue}>
                                    Yes
                                </button>
                                <button
                                    type="button"
                                    className="my-services-model-cancel-btn conv-mr25"
                                    onClick={() => {
                                        openConfirmationModalisFalse()
                                    }}>
                                    No
                                </button>
                            </div>

                        </div>
                    </div>
                </ModalContent>
            </Modal>

            <div style={{
                height: "75vh",
            }}>
                <div style={{
                    textAlign: 'right'
                }} className="mb-2">
                    <button className="my-services-model-submit-btn"
                        onClick={() => props.addCatalogueBtn()}
                    >Add Catalogue</button>
                </div>
                <div style={{ height: "100%", boxSizing: "border-box" }}>
                    <div style={gridStyle} className="ag-theme-material" >
                        {/* <AgGridReact ref={gridRef}
                            rowData={rowData}
                            gridOptions={gridOptions}
                            columnDefs={columnDefs}
                            pagination={true}
                            paginationPageSize={15}
                        >
                        </AgGridReact> */}

                        <AgGridReact ref={gridRef}
                            rowData={rowData}
                            gridOptions={gridOptions}
                            columnDefs={columnDefs}
                            // pagination={true}
                            // paginationPageSize={15}
                        >
                        </AgGridReact>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceCatalogueTable
